import {FC} from 'react';
import styles from './DownloadAppPage.module.css';

const DOWNLOAD_URL = 'https://trk.mail.ru/c/chbn09';
const QR_SRC = '/assets/img/rocketwork/lk-download-qr.png';

const SUBTEXT = 'Чтобы закончить регистрацию и пользоваться сервисом на 100%';

export const DownloadAppPage: FC = () => {
	return (
		<div className={styles.root}>
			<section className={styles.mobile} aria-label="Скачивание приложения">
				<header className={styles.mobileHeader}>
					<h1 className={styles.mobileTitle}>Скачайте наше приложение</h1>
					<p className={styles.subtitle}>{SUBTEXT}</p>
				</header>
				<a className={styles.mobileCta} href={DOWNLOAD_URL} rel="noopener noreferrer" target="_blank">
					Скачать приложение
				</a>
			</section>

			<section className={styles.desktop} aria-label="Скачивание приложения">
				<div className={styles.desktopText}>
					<h1 className={styles.desktopTitle}>Отсканируйте QR-код, чтобы скачать приложение</h1>
					<p className={styles.subtitle}>{SUBTEXT}</p>
				</div>
				<a
					className={styles.desktopQr}
					href={DOWNLOAD_URL}
					rel="noopener noreferrer"
					target="_blank"
					aria-label="Перейти по ссылке скачивания (как в QR-коде)"
				>
					{/* eslint-disable-next-line @next/next/no-img-element -- static public asset, Vite app */}
					<img className={styles.qrImage} src={QR_SRC} alt="QR-код: скачать приложение Рокет Ворк" />
				</a>
			</section>
		</div>
	);
};
